import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";

import { HvButton, HvInput } from "@hitachivantara/uikit-react-core";
import { Add } from "@hitachivantara/uikit-react-icons";

import { Filter } from "lib/utils/filterUtils";
import useStyles from "./styles";
import WokflowFilter from "../WorkflowFilter";

interface WorkflowControls {
  onSearch: (value: string) => void;
  onFilter: (value: number[][]) => void;
  filters?: number[][];
  baseFilter?: Filter[];
}

const WorkflowTableControls: React.FC<WorkflowControls> = ({
  onSearch,
  onFilter,
  filters,
  baseFilter,
}) => {
  const { t } = useTranslation("common");
  const history = useHistory();
  const { url } = useRouteMatch();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HvInput
        className={classes.inputPlaceholder}
        aria-label={t("common:search.ariaLabel")}
        placeholder={t("common:search.placeholder")}
        type="search"
        onEnter={(event, value) => onSearch?.(value)}
      />
      <WokflowFilter
        onChange={onFilter}
        filters={filters}
        baseFilter={baseFilter}
      />
      <HvButton
        className={classes.add}
        category="semantic"
        startIcon={<Add />}
        onClick={() => history.push(`${url}/add`)}
      >
        {t("common:buttons.add")}
      </HvButton>
    </div>
  );
};

export default WorkflowTableControls;
